import { Card, Row } from 'antd'
import React from 'react'
import Layout from '../components/common/Layout'

const Cookie: React.FC = () => {
  return (
    <Layout>
      <Row align='middle' justify='center'>
        <Card
          title='Політика використання файлів cookie'
          style={{ width: '90rem' }}
        >
          <p>
            Ця Політика використання файлів cookie пояснює як StrongMind Inc.
            («StrongMind», «ми», «нам» і «наш») використовує файли cookie й
            подібні технології відстежування на наших сайтах, зокрема{' '}
            <a href='https://strongmind.academy//'>
              https://strongmind.academy/
            </a>
            &nbsp;та будь-яких інших сайтах або додатках, що належать,
            використовуються або контролюються нами (спільно іменуються
            «сайти»), а також у випадках, коли підписники наших користувачів
            відвідують сайти або онлайн-магазини, що контролюються нашими
            користувачами, або відкривають/взаємодіють з електронними листами,
            відправленими через наші сервіси. Політика роз'яснює, що таке
            технології відстеження, як ми їх застосовуємо, а також ваші права
            контролювати використання нами вищезазначених технологій. Ця
            Політика є невід'ємною частиною{' '}
            <a href='/oferta'>Правил конфіденційності</a>. Терміни, які
            використовуються в цій Політиці використання файлів cookie,
            визначено у <a href='/oferta'>Політиці конфіденційності</a>.
          </p>
          <p>
            У деяких випадках ми можемо використовувати файли cookie та інші
            технології відстеження, описані в цій Політиці, для збору даних, які
            окремо або в сукупності з іншими даними, складають персональну
            інформацію. Детальніше про методи обробки персональної інформації
            див. у <a href='/oferta'>Політиці конфіденційності</a>.
          </p>
          <br></br>
          <h2>Визначення</h2>
          <p>
            Файли cookie — невеликі текстові файли, що зберігаються на вашому
            користувацькому пристрої при відвідуванні сайтів. Файли cookie
            широко використовуються для забезпечення або підвищення
            роботоздатності сайтів, а також для отримання аналітичної
            інформації.
          </p>
          <p>
            Файли cookie, встановлені власником сайту або постачальником послуг
            (у цьому випадку – StrongMind), називаються «власними файлами
            cookie». Файли cookie, встановлені компаніями, які не є власниками
            сайтів, які ви відвідуєте, називаються «сторонніми файлами cookie».
            Сторонні файли cookie дозволяють третім сторонам активувати свої
            компоненти або функції на або через сайт або сервіс, який ви
            використовуєте (наприклад, реклама, інтерактивний контент,
            інструменти аналітики). Треті сторони, що встановлюють сторонні
            файли cookie, можуть розпізнавати ваш пристрій при відвідуванні
            даного сайту або сервісу, а також деяких інших сайтів або сервісів.
          </p>
          <br />
          <h2>
            Для чого використовуються файли cookie та інші технології
            відстеження
          </h2>
          <p>
            Ми використовуємо власні й сторонні файли cookie з різними цілями.
            Деякі файли cookie потрібні для нормальної роботи наших сайтів і
            сервісів. Такі файли cookie називаються «важливими» або «строго
            необхідними». Інші файли cookie реєструють інформацію про зроблений
            вами вибір на сайтах і дозволяють нам і третім сторонам, з якими ми
            працюємо, налаштувати наші сайти згідно з вашими уподобаннями. Такі
            файли cookie називаються «експлуатаційними» або «функціональними».
            Наприклад, ми використовуємо файли cookie, щоб індивідуально
            підібрати контент, який ми розсилаємо або показуємо на наших сайтах,
            а також персоналізувати ваш досвід взаємодії з нашими сайтами і
            поліпшити їхню функціональність. Ми також дозволяємо нашим
            користувачам встановлювати файли cookie та подібні технології
            відстеження в рамках використання наших сервісів для відстеження та
            аналізу дій їхніх підписників. Зрештою, треті сторони встановлюють
            файли cookie через наші сайти або сервіси з рекламними, аналітичними
            та іншими цілями.
          </p>
          <br />

          <h2>Файли cookie, які передаються через наші сайти</h2>
          <p>
            Нижче описано конкретні види власних і сторонніх файлів cookie, що
            передаються через наші сайти.
          </p>
          <h3>Строго необхідні</h3>
          <p>
            Даний тип файлів cookie є обов'язковим, аби ви могли використовувати
            сайти та всі їхні функції, наприклад, доступ до захищених розділів.
            За бажання ви можете заблокувати або видалити ці файли cookie,
            змінивши відповідним чином налаштування вашого браузера, але ви
            повинні враховувати, що це позначиться на коректній роботі сайтів.
          </p>
          <h3>Експлуатаційні та функціональні</h3>
          <p>
            Файли цього типу використовуються для поліпшення функціональності
            наших сайтів, але не є обов'язковими. Однак, якщо ви вимкнете ці
            файли cookie, деякі функції наших сайтів стануть недоступними
          </p>
          <h3>Аналітичні й адаптаційні</h3>
          <p>
            Ці файли cookie дозволяють збирати інформацію, яка в сукупності
            допомагає нам зрозуміти, як використовуються наші сайти, і
            вимірювати ефективність наших маркетингових кампаній. Також ці файли
            допомагають нам адаптувати сайти і додатки до потреб користувача і
            покращувати взаємодію між користувачем і сайтами.
          </p>
          <h3>Рекламні</h3>
          <p>
            Дані файли cookie використовуються для відображення найбільш
            релевантних оголошень. Крім того, вони не допускають постійного
            відображення одного і того ж рекламного оголошення, забезпечують
            коректне відображення рекламних оголошень і, в деяких випадках,
            відбирають рекламні оголошення, засновані на ваших інтересах.
            Детальніше див. у пункті «Інтернет-реклама» .
          </p>
          <br />

          <h2>Інші технології відстеження</h2>
          <p>
            Ми й наші партнери можемо використовувати інші технології
            відстеження, зокрема веб-маяки та піксельні теги (або чисті GIF).
            Вони являють собою крихітні графічні об'єкти з унікальним
            ідентифікатором, який дозволяє визначати, коли ви відвідуєте наші
            сайти або відкриваєте наші електронні листи. Ми використовуємо цю
            технологію, наприклад, для відстеження переміщень користувачів по
            наших сайтах, передачі або взаємодії з файлами cookie, відображення
            цільової реклами, поліпшення роботи сайтів, вимірювання ефективності
            маркетингових кампаній, а також щоб бачити, коли користувач перейшов
            на наші сайти через інтернет-рекламу на сторонніх сайтах.
          </p>
          <p>
            Попри те, що ви не можете заблокувати або відключити подібні
            технології відстеження, у більшості випадків для їх роботи потрібні
            файли cookie. Тому відмова від прийому файлів cookie не дозволить їм
            коректно функціонувати.
          </p>
          <br />

          <h2 id='h178sjhkhdc0t96xqcztkaa9kw2yg4s'>Інтернет реклама</h2>
          <p>
            Ми залучили більше одного стороннього постачальника послуг, щоб
            відстежувати та аналізувати інформацію про індивідуальні
            відвідування наших сайтів і сукупні статистичні дані про взаємодію з
            нашими сайтами.
          </p>
          <p>
            Згадані незалежні постачальники послуг використовують файли cookie,
            веб-маяки, піксельні теги та подібні технології відстеження для
            збору і використання певної інформації про вашу мережеву активність
            на наших сайтах та/або на інших сайтах або мобільних додатках. Це
            дозволяє постачальникам послуг відправляти вам цільову рекламу на
            підставі вашої активності та інтересів.
          </p>
          <p>
            Незалежні постачальники послуг також можуть використовувати файли
            cookie або веб-маяки для збору інформації про ваше відвідування
            наших сайтів та/або інших сайтів для оцінки ефективності рекламних
            кампаній і маркетингової діяльності онлайн. Зібрана сторонніми
            постачальниками послуг інформація не включає персональні дані, які
            можуть дозволити розкрити вашу особистість (наприклад, ваше ім'я,
            електронна адреса).
          </p>
          <br />

          <h2>Файли cookie, які передаються через наші сервіси</h2>
          <h3>Користувацькі розсилки</h3>
          <p>
            Ми включаємо однопіксельні GIF або веб-маяки в усі листи,
            відправлені користувачами наших сервісів. Вони являють собою
            крихітні графічні об'єкти з унікальним ідентифікатором, який
            дозволяє нам і нашим користувачам відслідковувати, коли
            підписники&nbsp;відкривають відправлені листи і переходять за
            певними посиланнями. Ці технології фіксують електронну адресу
            кожного підписника, IP-адресу, дату і час відкриття або переходу в
            рамках розсилки. Ми використовуємо отримані дані для створення
            звітів про ефективність розсилки і дії підписників наших
            користувачів.
          </p>
          <h3>Користувацькі сайти</h3>
          <p>
            Якщо користувач вирішить застосовувати деякі додаткові налаштування
            або функції StrongMind, може знадобитися установка додаткових файлів
            cookie або інших технологій відстеження. Якщо користувач пов'язує
            свій сайт або онлайн-магазин (в обох випадках «сайт») з особистим
            кабінетом StrongMind, StrongMind встановлює невеликі фрагменти коду
            відстеження JavaScript («код») на даний сайт користувача. Цей код
            дозволяє встановити файли cookie, пікселі та інші технології
            відстеження на сайт користувача, щоб полегшити використання деяких
            функцій автоматизації, а також інших можливостей, доступних у
            сервісах StrongMind. Тип встановлюваних на користувацькому сайті
            файлів cookie, пікселів чи інших технологій залежить від обраних
            додаткових налаштувань і функцій, використовуваних в рамках сервісів
            StrongMind. Користувачі повинні ознайомитися з діючою{' '}
            <a href='/oferta'>Політикою конфіденційності </a> та Політикою
            використання файлів cookie для додаткової інформації про особливі
            типи файлів cookie або інших технологій відстеження, що
            використовуються на сайті.
          </p>
          <br />

          <h2>Як керувати файлами cookie</h2>
          <p>У вас є право прийняти або відхилити файли cookie.</p>
          <p>
            Ви можете регулювати використання файлів cookie через налаштування
            вашого браузера. Якщо ви вирішите відключити файли cookie, то все
            одно зможете використовувати наші сайти, хоч деякі розділи та
            функції наших сайтів не працюватимуть. Всі браузери відрізняються
            один від одного. Щоб зрозуміти як відключити файли cookie у вашому
            браузері, перевірте довідкове меню.
          </p>
          <br />

          <h2>Зміни Політики використання файлів cookie</h2>
          <p>
            Ми можемо оновлювати цю Політику в міру необхідності, наприклад, для
            відображення у ній змін, що стосуються використовуваних файлів
            cookie, а також спричинених операційними, юридичними або
            нормативними причинами.
          </p>
          <p>
            Ми рекомендуємо регулярно переглядати положення цієї Політики для
            отримання актуальної інформації про використовувані файли cookie і
            пов'язані з ними технології.
          </p>
          <p>Дата останнього оновлення вказана на початку цієї Політики.</p>
          <p>
            Якщо у вас виникнуть питання стосовно використання файлів cookie або
            інших технологій, звертайтесь до нас за адресою{' '}
            <a href='mailto:support@strong-mind.com'>support@strong-mind.com</a>
            .&nbsp;
          </p>
        </Card>
      </Row>
    </Layout>
  )
}

export default Cookie
